import PurchaseOrderAsetApi from "./PurchaseOrderAsetApi";

export default PurchaseOrderAsetApi;
